import { Card } from '@codametrix/ui-components';
import { push } from 'connected-react-router';
import { objectUtils } from '@codametrix/ui-common';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

const ServiceLineMessage = () => {
  const { serviceLine } = useSelector(
    (state: CMx.ApplicationState) => state.ui
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const path = history.location.pathname;
  const actionGroups = useSelector(
    (state: CMx.ApplicationState) => state.ui.actionGroups
  );
  const activeActionGroupKey = actionGroups.find(
    ag => ag.options[0].active === true
  )?.key;
  useEffect(() => {
    if (serviceLine) {
      const serviceLinePath = serviceLine.name.toLowerCase();
      const expectedPath = `${path}${serviceLinePath}/`;
      
      // Only navigate if the current path doesn't already end with the service line
      // This prevents the infinite loop when navigation updates the path
      if (!path.endsWith(`${serviceLinePath}/`)) {
        dispatch(push(expectedPath));
      }
    }
    // Only re-run when serviceLine.name or path actually changes, not when serviceLine object reference changes
  }, [serviceLine?.name, dispatch, path]);

  if (!serviceLine) {
    return (
      <Card className={'content-vacant qa-service-line-message'}>
        <h2>
          <b>No service line available</b>
        </h2>
        <h4>
          {objectUtils.startCase(activeActionGroupKey)} requires a service line.
          Please contact an administrator to add one.
        </h4>
        <p> support@codametrix.com </p>{' '}
      </Card>
    );
  } else {
    return <div className={'qa-empty-service-line-message'}></div>;
  }
};

export default ServiceLineMessage;
